import React, { useEffect, useState } from "react";
import "../create/Student_Detail_Create.css";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { AllHosts } from "../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { GetHost } from "../../../../features/admin/host/slice";
import Success_Modal from "../../../common_components/common-modal/success_modal/Success_Modal";
import Reject_Modal from "../../../common_components/common-modal/reject_modal/Reject_Modal";

import {
  GetAllCustomer,
  GetCustomer,
  UpdateCustomer,
} from "../../../../features/admin/customer/Slice";
import { Form } from "react-bootstrap";
import { faEye, faEyeSlash, faL } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Student_Detail_Create = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showSuccess, setShowSuccess] = useState(false);
  const [showReject, setShowReject] = useState(false);

  const { id } = useParams();

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    watch,
  } = useForm({});

  const [showPassword, setShowPassword] = useState({
    password: false,
    confirm: false,
  });

  const togglePasswordVisibility = (type) => {
    setShowPassword((prev) => ({ ...prev, [type]: !prev[type] }));
  };
  const newPassword = watch("password", "");

  const allHostData = useSelector((state) => state.common.all_hosts);

  useEffect(() => {
    dispatch(AllHosts());
  }, [dispatch]);

  const GetData = async (hostId) => {
    try {
      const res = await dispatch(GetCustomer(hostId)).unwrap();

      const hostData = res?.data;

      if (!hostData) {
        return;
      }

      reset({
        user_name: hostData?.user_name || "",
        user_id: hostData?.user_id || "",
        reference: hostData?.reference || "",
        password: hostData?.password || "",
        confirm_password: hostData?.password || "",
        added_by_id: hostData?.added_by_id
          ? {
              value: hostData.added_by_id.value,
              label: hostData.added_by_id.label,
            }
          : null,
      });
    } catch (error) {
      console.error("Get Host Error:", error);
    }
  };

  useEffect(() => {
    if (id) {
      GetData(Number(id));
    }
  }, [id]);

  const onSubmit = async (data) => {
    try {
      const payload = {
        user_name: data.user_name,
        added_by_id: data.added_by_id,
        user_id: data.user_id,
        reference: data.reference,
        password: data.password,
      };

      const res = await dispatch(
        UpdateCustomer({
          id,
          data: payload,
        }),
      ).unwrap();

      if (res?.success) {
        dispatch(GetAllCustomer());

        setShowSuccess(true);

        setTimeout(() => {
          setShowSuccess(false);
          navigate(-1);
        }, 3000);
      } else {
        setShowReject(true);

        setTimeout(() => {
          setShowReject(false);
        }, 3000);
      }
    } catch (error) {
      console.error("Update Customer Error:", error);

      setShowReject(true);

      setTimeout(() => {
        setShowReject(false);
      }, 3000);
    }
  };
  return (
    <section className="Student_Detail_Create common_section">
      <div className="section_filter_div">
        <p className="filter_title">Edit Student</p>
      </div>

      <div className="host-user-card">
        {" "}
        <div className="form-ro">
          <div className="form-control-wrapper1">
            <button
              type="submit"
              className="submit-btn"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
          </div>
          <br />
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="form-wrapper-div">
          <div className="form-row">
            <label className="form-label">
              Users Host <span>*</span>
            </label>

            <div className="form-control-wrapper">
              <Controller
                name="added_by_id"
                control={control}
                rules={{ required: "Host is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={allHostData}
                    onInputChange={(val) => {
                      dispatch(AllHosts(val));
                    }}
                  />
                )}
              />
              {errors?.added_by_id && (
                <Form.Text className="text-danger">
                  {errors?.added_by_id?.message}
                </Form.Text>
              )}
            </div>
          </div>
          <div className="form-row">
            <label className="form-label">
              Users Name <span>*</span>
            </label>

            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="Users Name"
                className="form-input"
                {...register("user_name", {
                  required: "Users Name is required",
                })}
              />

              {errors.user_name && (
                <span className="text-danger">{errors.user_name.message}</span>
              )}
            </div>
          </div>
          <div className="form-row">
            <label className="form-label">
              Users Id <span>*</span>
            </label>

            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="Users Id"
                className="form-input"
                {...register("user_id", {
                  required: "Users Id is required",
                })}
              />

              {errors.user_id && (
                <span className="text-danger">{errors.user_id.message}</span>
              )}
            </div>
          </div>{" "}
          <div className="form-row">
            <label className="form-label">
              Reference <span>*</span>
            </label>

            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="Reference"
                className="form-input"
                {...register("reference", {
                  required: "Reference is required",
                })}
              />

              {errors.reference && (
                <span className="text-danger">{errors.reference.message}</span>
              )}
            </div>
          </div>
          <div className="form-row">
            <label className="form-label">
              Password <span>*</span>
            </label>
            <div className="form-control-wrapper">
              <Form.Group>
                <div style={{ position: "relative" }}>
                  <Form.Control
                    type={showPassword.password ? "text" : "password"}
                    placeholder="Enter Password"
                    {...register("password", {
                      required: " Password is required",
                    })}
                    className={errors.password ? "is-invalid" : ""}
                  />
                  <FontAwesomeIcon
                    icon={showPassword.password ? faEye : faEyeSlash}
                    className="password-toggle-icon"
                    onClick={() => togglePasswordVisibility("password")}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  />
                </div>

                {errors.password && (
                  <Form.Text className="text-danger">
                    {errors.password.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
          </div>
          {/* Confirm Password */}
          <div className="form-row">
            <label className="form-label">
              Confirm New Password <span>*</span>
            </label>
            <div className="form-control-wrapper">
              <Form.Group>
                <div style={{ position: "relative" }}>
                  <Form.Control
                    type={showPassword.confirm ? "text" : "password"}
                    placeholder="Enter Confirm Password"
                    {...register("confirm_password", {
                      required: "Confirm Password is required",
                      validate: (value) =>
                        value === newPassword || "Passwords do not match",
                    })}
                    className={errors.confirm_password ? "is-invalid" : ""}
                  />
                  <FontAwesomeIcon
                    icon={showPassword.confirm ? faEye : faEyeSlash}
                    className="password-toggle-icon"
                    onClick={() => togglePasswordVisibility("confirm")}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  />
                </div>
                {errors.confirm_password && (
                  <Form.Text className="text-danger">
                    {errors.confirm_password.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
          </div>
          <div className="form-row">
            <div className="form-label"></div>

            <div className="form-control-wrapper">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
      <Success_Modal
        show={showSuccess}
        onHide={() => {
          setShowSuccess(false);
          navigate(-1);
        }}
      />

      <Reject_Modal
        show={showReject}
        onHide={() => {
          setShowReject(false);
          navigate(-1);
        }}
      />
    </section>
  );
};

export default Student_Detail_Create;
